import React, { useEffect, useRef, useState } from 'react';
import ComPatSearch from './ComPatSearch';
import SearchStaffUser from '../../Utilities/SerchStafUser';
import { post } from '../Auths/AuthToken';
// import { debounce } from 'lodash';
import setUiMessage from '../../Utilities/Tostify';
import CommonUploadFile from '../../Utilities/CommonUploadFile';
import ComGrpSearchSpan from './ComGrpSearchSpan';
import { useSelector } from 'react-redux';

function ComPatientEmailCompose({
  close,
  msgType,
  userPat,
  handleReload = () => {},
}) {
  const { user } = useSelector((state) => state.auth);
  const inputRef = useRef(null);

  const [selectedPats, setSelectedPats] = useState([]);
  const [taggedStaff, setTaggedStaff] = useState([]);
  const [tempMsgString, setTempMsgString] = useState('');
  const [subject, setSubject] = useState('');
  const [searchTemplates, setSearchTemplates] = useState([]);
  const [isDivHidden, setIsDivHidden] = useState(false);
  // const [selectedResult, setSelectedResult] = useState(null);
  const [uploadAttachment, setUploadAttachment] = useState([]);

  const defComPat = userPat
    ? {
        userId: userPat.user_id,
        passPaientNameInJsFun: userPat.patName,
        dob: userPat.dob,
        age: userPat.age,
        gender: userPat.gender,
        chart_number: userPat.chart_number,
        mobile: userPat.mobile,
        email: userPat.email,
      }
    : '';

  const handleSendEmail = async () => {
    let prams = {
      subject: subject,
      to: selectedPats.map((item) => item.userId).join(','),
      compose_message: tempMsgString.trim(),
      msgType: '1', // 0 or 1
      attachments: uploadAttachment,
      tagStaff: taggedStaff.map((item) => item.staff_id).join(','),
      loginUserId: user?.id,
    };

    if (msgType === '1') {
      prams = { ...prams, msgType: '1', attachments: '' };
    } else {
      prams = { ...prams, msgType: '0' };
    }

    if (!prams?.to) {
      setUiMessage('err', 'Please select to patient.');
    } else if (!prams.compose_message) {
      setUiMessage('err', 'Please write some message.');
    } else {
      try {
        const response = await post(
          'api/communication/Communication/sendEmailMsg',
          {
            ...prams,
          }
        );

        if (response.status === 200) {
          if (response?.data?.status === 'success') {
            setUiMessage('suc', 'Message sent successfully.');
            handleReload();
            close();
          } else {
            setUiMessage('err', response?.data?.msg);
          }
        }
      } catch (err) {
        setUiMessage('suc', err.message);
      }
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef?.current && !inputRef?.current.contains(event.target)) {
        setIsDivHidden(true);
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [inputRef]);

  // useEffect(() => {
  //   let isCancelled = false;

  //   const debouncedFetchResults = debounce(async (term) => {
  //     try {
  //       const response = await post(
  //         'api/communication/Communication/getSubjectList',
  //         {
  //           subText: term,
  //           mode: 'intraEmailComm',
  //           loginUserId: user?.id,
  //         }
  //       );

  //       if (!isCancelled && response.status === 200) {
  //         setIsDivHidden(false);
  //         setSearchTemplates(response?.data?.subjectList || []);
  //       }
  //     } catch (err) {
  //       setUiMessage('suc', err.message);
  //     } finally {
  //       setIsDivHidden(false);
  //     }
  //   }, 500);

  //   if (subject.trim() !== '' && selectedResult !== subject) {
  //     debouncedFetchResults(subject);
  //   } else {
  //     setSearchTemplates([]);
  //   }

  //   return () => {
  //     isCancelled = true;
  //     debouncedFetchResults.cancel(); // Cancel any pending debounce on cleanup
  //   };
  // }, [subject, user?.id, selectedResult]);

  const handleMsg = (selectedSubject) => {
    setSubject(selectedSubject);
    // setSelectedResult(selectedSubject);
  };

  return (
    <div className="modalBackground">
      <div className="compose-msg-main-con grid-sec tab-bg">
        <div className="comp-msg-hdr flex-sec">
          New Message (Medgre comm & email notifications)
        </div>

        <div className="comp-msg-bdy grid-sec">
          <div className="comp-msg-bdy-rw flex-sec orange-txt">
            <i>
              This message sent over Medgre communication portal & email
              notifications: Do not include PHI; select Secure Message sent over
              the Patient Portal for PHI.
            </i>
          </div>
          <ComPatSearch
            defaultPat={defComPat ? [defComPat] : undefined}
            msgType="email"
            bigSearchBox={true}
            fieldName="To"
            changeShow={false}
            handlePatArr={setSelectedPats}
          />
          {(() => {
            if (msgType === '1') {
              return (
                <>
                  <ComGrpSearchSpan
                    handleTaggedStaff={(staffs) => setTaggedStaff(staffs)}
                  />
                  <SearchStaffUser
                    fieldName="Tag Staff"
                    key={Math.random()}
                    tagStaffUser={taggedStaff}
                    handleTaggedStaff={setTaggedStaff}
                  />
                </>
              );
            } else {
              return (
                <div
                  ref={inputRef}
                  className="comp-msg-bdy-rw grid-sec"
                  style={{ position: 'relative' }}
                >
                  <div className="comp-msg-bdy-chld-rw flex-sec">
                    <span className="msg-bdy-rw-bl">{'Document'}:</span>
                    <span className="msg-bdy-rw-val">
                      <CommonUploadFile
                        apiUri={'api/communication/Communication/fileToUpload'}
                        handleUploadFile={(files) => setUploadAttachment(files)}
                      />
                    </span>
                  </div>
                </div>
              );
            }
          })()}

          <div
            ref={inputRef}
            className="comp-msg-bdy-rw grid-sec"
            style={{ position: 'relative' }}
          >
            <div className="comp-msg-bdy-chld-rw flex-sec">
              <span className="msg-bdy-rw-bl">Subject:</span>
              <span className="msg-bdy-rw-val">
                <input
                  type="text"
                  className="msg-inpt"
                  placeholder="Write the subject of the message or select a template from the list..."
                  style={{ width: '92%' }}
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </span>
            </div>
            <div className="comp-msg-bdy-chld-rw flex-se">
              <div
                className={`search-user-pnl grid-sec ${
                  isDivHidden ? 'hide' : ''
                }`}
              >
                {searchTemplates.map((idx, i) => (
                  <span
                    onClick={() => handleMsg(idx.subject)}
                    key={i}
                    className="usr-name"
                  >
                    {idx.subject}
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className="comp-msg-bdy-rw flex-sec">
            <span className="msg-bdy-rw-bl">Message:</span>
            <span className="msg-bdy-rw-val">
              <textarea
                className="msg-bdy"
                placeholder="Write your message here"
                onChange={(e) => setTempMsgString(e.target.value)}
                onFocus={() => setSearchTemplates([])}
                value={tempMsgString}
              ></textarea>
            </span>
          </div>
        </div>
        <div className="comp-msg-ftr flex-sec">
          <button className="actn-yes" onClick={handleSendEmail}>
            Send
          </button>
          <button className="actn-No" onClick={close}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default ComPatientEmailCompose;
